import {AxiosError} from 'axios';
import {
  AnnouncementDetail,
  PostSearchAnnouncementsRequest,
} from 'web-library/models/Announcements';
import {PaginatedData} from 'web-library/models/List';
import {POST_SEARCH_ANNOUNCEMENTS_URL} from 'web-library/constants/apiUrls';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PaginatedData<AnnouncementDetail>) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  isRedirect?: boolean;
}

export const usePostSearchAnnouncements = ({
                                             onSuccess,
                                             onError,
                                             isRedirect = true,
                                           }: Input = {}) => {
  const postSearchAnnouncements = async (payload: PostSearchAnnouncementsRequest) => {
    const examCentreNoticeBoard = payload.examCentreNoticeBoard
        ? payload.examCentreNoticeBoard
        : 'NOT_EXAM_CENTRE_NOTICE_BOARD';

    const res = await axiosClient.post(
        POST_SEARCH_ANNOUNCEMENTS_URL(payload.announcementType, payload.apiPathParam),
        {
          q: payload.q,
          examCentreNoticeBoard,
        },
        {
          headers: payload.headers || {},
        }
    );
    return res.data;
  };

  return useCustomMutation(
      postSearchAnnouncements,
      {
        onSuccess,
        onError,
      },
      false,
      isRedirect
  );
};
